import React, { useEffect, useState } from 'react';
import { Box, CssBaseline, IconButton, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MenuIcon from '@mui/icons-material/Menu';
import { Outlet } from 'react-router-dom';
import SidebarContent from './Sidebar';

const drawerWidth = 240;
const collapsedDrawerWidth = 65;

export default function CvAdminLayout() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [open, setOpen] = useState(!isMobile);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    if (isMobile) {
      setOpen(false);
      return;
    }

    setOpen(true);
    setMobileOpen(false);
  }, [isMobile]);

  const handleDrawerToggle = () => {
    if (isMobile) {
      setMobileOpen((prev) => !prev);
      return;
    }

    setOpen((prev) => !prev);
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
      <CssBaseline />
      <SidebarContent
        drawerWidth={drawerWidth}
        open={open}
        mobileOpen={mobileOpen}
        isMobile={isMobile}
        onCloseMobile={() => setMobileOpen(false)}
        onNavigate={() => setMobileOpen(false)}
        onToggle={handleDrawerToggle}
      />

      {isMobile && !mobileOpen && (
        <IconButton
          onClick={handleDrawerToggle}
          aria-label="Abrir menu"
          sx={{
            position: 'fixed',
            top: 12,
            left: 12,
            zIndex: (muiTheme) => muiTheme.zIndex.drawer + 2,
            width: 44,
            height: 44,
            bgcolor: 'background.paper',
            color: 'text.primary',
            border: '1px solid',
            borderColor: 'divider',
            boxShadow: 3,
            '&:hover': {
              bgcolor: 'grey.50',
            },
          }}
        >
          <MenuIcon />
        </IconButton>
      )}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          width: {
            xs: '100%',
            sm: `calc(100% - ${open ? drawerWidth : collapsedDrawerWidth}px)`,
          },
          p: { xs: 2, sm: 3 },
          pt: { xs: 8, sm: 3 },
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
